var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7001 7.56055H5.89551V34.9907H33.7001V7.56055Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7539 43.0215C8.18204 43.0215 0 34.9908 0 21.439C0 7.88727 7.8793 0 20.4511 0C33.0229 0 41.2767 7.79963 41.2767 21.439C41.2767 35.0784 33.3257 43.0215 20.7459 43.0215H20.7539ZM24.4824 17.8778C19.0171 12.4125 15.91 11.7751 13.3924 14.2847C10.8191 17.0731 11.576 20.0687 17.0333 25.534C22.4429 30.9436 25.3349 31.2623 27.9002 28.6969C30.4656 26.1315 30.0991 23.5025 24.4744 17.8778H24.4824Z",
    fill: "#F2F2E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.2767,
    height: 43.0215,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logoFooter.eabfcf3a4303c54233784da9dbecbace.svg";
export { ForwardRef as ReactComponent };